export default state => {
  return state.info
}
